import * as types from '../../core/constants/ActionTypes';
import * as staticConstants from '../../core/constants/staticConstants';
import {getBaseUrl, getHost} from '../../core/utility/filter.utility';

import {getQueryStringKeyValue} from '../components/url-reader/url-reader';

import {
    takeLatest,
    call,
    put
} from 'redux-saga/effects';

import axios from 'axios';

// reducer with initial state
const initialState = {
    isAuthenticated: 'pending',
    isAuthorized: 'pending',
    error: null,
    isLpAuthFail: false
};

export function loginReducer(state = initialState, action) {
    switch (action.type) {
        case types.IS_AUTHORIZED:
            return {...state,
                isAuthorized: action.payload,
                error: null
            };
        case types.AUTHENTICATED:
            return {...state,
                isAuthenticated: action.payload
            };
        case types.IS_LOGIN_ERROR:
            return {...state,
                error: action.payload
            };
        case types.SET_IS_LP_AUTH_FAIL:
            return {...state, isLpAuthFail: action.payload};
        default:
            return state;
    }
}

// function that makes the api request and returns a Promise for response
function authenticateUser(reqObj) {
    let authenticateUrl = `${getBaseUrl()}/rest/up/authenticateService/authenticate?`;
    if (reqObj.lexType) {
        authenticateUrl += `&lexType=${reqObj.lexType}`;
    }
    if (reqObj.cId) {
        authenticateUrl += `&cId=${reqObj.cId}`;
    }
    if (reqObj.cType) {
        authenticateUrl += `&cType=${reqObj.cType}`;
    }
    if (reqObj.rcType) {
        authenticateUrl += `&rc_Type=${reqObj.rcType}`;
    }
    if (reqObj.pId) {
        authenticateUrl += `&pId=${reqObj.pId}`;
    }
    if (window.lmsUrl) {
        authenticateUrl += `&lmsURL=${window.lmsUrl}`;
    } else if (reqObj.lmsUrl) {
        authenticateUrl += `&lmsURL=${reqObj.lmsUrl}`;
    }
    if (reqObj.lcoId) {
        authenticateUrl += `&lcoId=${reqObj.lcoId}`;
    }
    if (reqObj.lang) {
        authenticateUrl += `&lang=${reqObj.lang}`;
    }
    if (reqObj.learnerId) {
        authenticateUrl += `&learnerId=${reqObj.learnerId}`;
    }
    if (reqObj.audience) {
        authenticateUrl += `&audience=${reqObj.audience}`;
    }
    if (reqObj.lmsId) {
        authenticateUrl += `&lId=${reqObj.lmsId}`;
    }
    if (reqObj.skUid) {
        authenticateUrl += `&skUid=${reqObj.skUid}`;
    }
    if (reqObj.scUid) {
        authenticateUrl += `&scUid=${reqObj.scUid}`;
    }
    if (reqObj.isGuide) {
        authenticateUrl += `&isGuide=${reqObj.isGuide}`;
    }
    if (reqObj.lpId) {
        authenticateUrl += `&lpId=${reqObj.lpId}`;
    }
    if (reqObj.authVer) {
        authenticateUrl += `&authVersion=${reqObj.authVer}`;
    }
    if (reqObj.pURL) {
        authenticateUrl += `&pURL=${reqObj.pURL}`;
    }
    if (reqObj.aTy) {
        authenticateUrl += `&aTy=${reqObj.aTy}`;
    }
    if (reqObj.tenantId) {
        authenticateUrl += `&tenantId=${reqObj.tenantId}`;
    }
    if (reqObj.nW) {
        authenticateUrl += `&nW=${reqObj.nW}`;
    }
    if (reqObj.lpCode) {
        authenticateUrl += `&lpCode=${reqObj.lpCode}`;
    }
    return axios({
        method: 'get',
        url: authenticateUrl
    });
}

// worker saga: makes the api call when watcher saga sees the action
function* loginWorkerSaga(request) {
    try {
        const response = yield call(authenticateUser, request.payload);
        const auth = response.data.autht.toString();
        console.log('----Response from Authenticate API----', response.data.rUrl);
        const loginRes = response.data;

        if ((request.payload.lpId || request.payload.lpCode) && loginRes && request.payload.clsAud === 's' && loginRes.autht) {
            const key = getQueryStringKeyValue('key', loginRes.rUrl);
            const learnerId = getQueryStringKeyValue('learnerId', loginRes.rUrl);
            yield put({
                type: types.SET_SESSION_ID,
                payload: key
            });
            yield put({
                type: types.SET_LERNERID_ID,
                payload: learnerId
            });
        } else if (loginRes) {
            if (loginRes.rUrl) {
                window.location = loginRes.rUrl;
                return;
            }
        }

        // if (loginRes) {
        //     window.location = loginRes.rUrl;
        //     console.log(window.location);
        //     console.log(loginRes.rUrl);
        // }

        if (loginRes.learnerId) {
            yield put({
                type: types.SET_LEARNER_ID,
                payload: loginRes.learnerId
            });
        }
        // dispatch a success action to the store with session key
        yield put({
            type: types.SET_SESSION_ID,
            payload: loginRes.key
        });

        // dispatch a success action to the store with authentication
        yield put({
            type: types.AUTHENTICATED,
            payload: auth
        });
        if (!loginRes.autht) {
            if (request.payload.lpId || request.payload.lpCode) {
                // debugger;
                yield put({
                    type: types.SET_IS_LP_AUTH_FAIL,
                    payload: true
                });
            } else {
                const login = `Click <a href='${getHost()}' target='_blank'>here</a> to retry to login`;
                yield put({
                    type: types.SET_EXCEPTION,
                    payload: {
                        type: staticConstants.EXCP_ERROR,
                        desc: loginRes.desc.concat('<center><br>', login, '</center>')
                    }
                });
                yield put({
                    type: types.SET_LOADER,
                    payload: false
                });
            }
        }
    } catch (error) {
        // dispatch a failure action to the store with the error
        yield put({
            type: types.AUTHENTICATED,
            payload: 'false'
        });
        if (error.response) {
            yield put({
                type: types.IS_LOGIN_ERROR,
                payload: error.response.data
            });
        }
        yield put({
            type: types.SET_EXCEPTION,
            payload: {
                type: staticConstants.EXCP_ERROR,
                desc: 'Error while login. Issue might be due to 3DS Learning Space authentication service.'
            }
        });
    }
}

// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* loginWatcherSaga() {
    yield takeLatest(types.IS_AUTHENTICATED, loginWorkerSaga);
}
